import { calculateOrderCurrentPrice, getTokenCurrencyByAddr } from '../utils/helpers';
import { iOption, iOrder, iOrderResponse } from '../interfaces/interfaces';
import { blockchain } from '../settings';
import { store } from '../store/store';
import { cOption } from './option';
import { cBigNumber } from './BigNumber';


export class cOrder implements iOrder {
	ordId: number;
	ordType: boolean;   // true => sell, false => buy
	optId: number;
	owner: string
	amount: cBigNumber;
	refPrice: cBigNumber;
	delta: cBigNumber;
	ordPrice: cBigNumber;
	minMaxPrice: cBigNumber;
	currentPrice: cBigNumber;
	// option: iOption | undefined = undefined;

	constructor(orderResponse: iOrderResponse, optionUToken? : string){
		this.ordId = orderResponse.ord_id;
		this.ordType = orderResponse.ord_type;
		this.optId = orderResponse.opt_id;
		this.owner = orderResponse.owner;
		this.amount = new cBigNumber(orderResponse.amount);
		this.refPrice = new cBigNumber(orderResponse.ref_price);
		this.delta = new cBigNumber(orderResponse.delta);
		this.ordPrice = new cBigNumber(orderResponse.ord_price);
		this.minMaxPrice = new cBigNumber(orderResponse.min_max_price);

		// current price
		if (orderResponse.option || optionUToken){  // can calculate real price

			switch (blockchain) {
				case 'binance':
					const currentUToken = orderResponse.option? getTokenCurrencyByAddr(orderResponse.option.u_token) : optionUToken;
					const currentPrice = store.getState().app.tokensPrices.find(price => price.currency === currentUToken);

					if(!currentPrice || !currentPrice.price) throw new Error(`Error code: 2_1\nu_tok: ${currentUToken}`);

					this.currentPrice = calculateOrderCurrentPrice(
						orderResponse.ord_type,
						new cBigNumber(orderResponse.ref_price),
						new cBigNumber(orderResponse.delta),
						new cBigNumber(orderResponse.ord_price),
						new cBigNumber(orderResponse.min_max_price),
						currentPrice.price
					);
					break;

				case 'chromia':
					this.currentPrice = this.ordPrice;	// not true. need getOrderPriceQuery
					break;

				default:
					throw new Error('Error code: 2_2\nBC: ' + blockchain);
			}
		} else {
			throw new Error(`Error code: 2_0`);
		}

		// option
		/* if (orderResponse.option){
			this.option = new cOption(orderResponse.option);
		} */
	}
}